import { Text } from '@mantine/core';

type StatisticProps = {
  title?: string;
  value?: number;
  suffix?: string;
};

const Statistic = (props: StatisticProps) => {
  const { title = '', value = undefined, suffix = '' } = props;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
      <Text c="gray.5">{title}</Text>

      <Text c="gray.5" size="xl">
        {suffix} {value?.toLocaleString()}
      </Text>
    </div>
  );
};

export default Statistic;
